import {EventDataType, fireFBEvent} from "../api/fb-analyticService";
import {useAppState} from "../store/useAppState";
import {getHash} from "./funnelHelpers";

// Get a cookie value by name, returns undefined if not present or not in a browser context
const getCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') return undefined;
  const pairs = document.cookie.split('; ');
  for (const pair of pairs) {
    const eqIdx = pair.indexOf('=');
    if (eqIdx === -1) continue;
    const key = pair.slice(0, eqIdx);
    if (key === name) {
      return decodeURIComponent(pair.slice(eqIdx + 1));
    }
  }
  return undefined;
}

export const facebookEventFire = (eventName: string, data?: EventDataType) => {
  const {facebookEventsHash, setFacebookEventsHash} = useAppState.getState();

  const eventData = {eventName, ...data};
  const hash = getHash(JSON.stringify(eventData));

  // console.log('facebook event fire', eventData, hash);

  if (!facebookEventsHash[hash]) {
    setFacebookEventsHash(hash);
    if (process.env.REACT_APP_ENV !== 'development') {
      const click_ids = JSON.parse(localStorage.getItem('click_ids') || '{}');
      const newData: EventDataType = (data || { userData: {} }) as EventDataType;

      // Set Facebook click id (fbc) if available
      if (click_ids?.fbclid) {
        newData.userData.fbc = click_ids.fbclid;
      }

      // Read Meta Pixel _fbp cookie and set it to userData.fbp if found
      const fbp = getCookie('_fbp');
      if (fbp) {
        newData.userData.fbp = fbp;
      }

      //read email from local storage
      const email = localStorage.getItem('emailAddress');
      if (email) {
        newData.userData.em = email;
      }
      // console.log('sending facebook data', eventName, newData, hash);
      fireFBEvent(eventName, newData).catch(err => console.error('error while try to send facebook event', err));
    }
  } else {
    console.log('facebook event avoid', eventData, hash);
  }
}
